import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export function SearchShortcutHint({
  shortcutHint,
  field,
}: Readonly<{
  shortcutHint: string | null;
  field: boolean;
}>) {
  return (
    <>
      {shortcutHint !== null && (
        <span
          aria-hidden="true"
          {...stylex.props(
            styles.hint,
            field ? styles.fieldHint : styles.drawerHint,
          )}
        >
          {shortcutHint}
        </span>
      )}
    </>
  );
}

const styles = stylex.create({
  hint: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    borderRadius: 3,
    backgroundColor: colors.surfaceAlt,
    color: colors.muted,
    fontFamily: fonts.sans,
    fontWeight: 400,
  },
  fieldHint: {
    marginInlineStart: "auto",
    minWidth: 28,
    height: 19,
    paddingInline: spacing.space4,
    fontSize: fontSizes.caption,
  },
  drawerHint: {
    minWidth: 36,
    height: 24,
    paddingInline: spacing.space8,
    fontSize: fontSizes.label,
  },
});
